import LumerAIBulkActionsAPI from 'dashboard/api/lumerai/bulkActions';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

export default createStore({
  name: 'LumerAIBulkAction',
  API: LumerAIBulkActionsAPI,
  actions: mutations => ({
    processBulkAction: async function processBulkAction(
      { commit },
      { type, actionType, ids }
    ) {
      commit(mutations.SET_UI_FLAG, { isUpdating: true });
      try {
        const response = await LumerAIBulkActionsAPI.create({
          type: type,
          ids,
          fields: { status: actionType },
        });
        commit(mutations.SET_UI_FLAG, { isUpdating: false });
        return response.data;
      } catch (error) {
        commit(mutations.SET_UI_FLAG, { isUpdating: false });
        return throwErrorMessage(error);
      }
    },

    handleBulkDelete: async function handleBulkDelete(
      { dispatch },
      { type = 'AssistantResponse', ids }
    ) {
      const response = await dispatch('processBulkAction', {
        type,
        actionType: 'delete',
        ids,
      });

      if (type === 'AssistantResponse') {
        // Update the response store after successful API call
        await dispatch('lumeraiResponses/removeBulkResponses', ids, {
          root: true,
        });
      } else if (type === 'AssistantDocument') {
        await dispatch('lumeraiDocuments/removeBulkRecords', ids, {
          root: true,
        });
      }
      return response;
    },

    handleBulkApprove: async function handleBulkApprove({ dispatch }, ids) {
      const response = await dispatch('processBulkAction', {
        type: 'AssistantResponse',
        actionType: 'approve',
        ids,
      });

      // Update response store after successful API call
      await dispatch('lumeraiResponses/updateBulkResponses', response, {
        root: true,
      });
      return response;
    },

    handleBulkSync: async function handleBulkSync({ dispatch }, { ids }) {
      const response = await dispatch('processBulkAction', {
        type: 'AssistantDocument',
        actionType: 'sync',
        ids,
      });

      await dispatch('lumeraiDocuments/markSyncing', response.ids || [], {
        root: true,
      });
      return response;
    },
  }),
});
